import React from 'react';
import PropTypes from 'prop-types';
import styles from './card.scss';

const Card = props => <div className={styles.card}>{props.children}</div>;

Card.propTypes = {
  children: PropTypes.node,
};

export default Card;
